<template>
    <div ref="detailContainer" class="app-detail-container">
        <section>
            <screen-shot
                :media="media"
            />
        </section>
        <section>
            <detail-info
                :info="info"
                :app-detail="appDetail"
                :media="mediaWeak"
                :is-mobile="isMobile"
                :is-vertical="isVertical"
                :is-show-product-detail="isShowProductDetail"
                :video-vertical="videoisVertical"
                :is-official="$root.officialJoinedStyle"
                :buy-url-info="buyUrlInfo"
                :discuss-zone="discussZone ? discussZone : {}"
                :official-time-axis="officialTimeAxis ? officialTimeAxis : {}"
                :is-cooperation="isCooperation"
                :comment-cnt="appDetail.commentCnt"
                :download-num="downloadNum"
                :baidu-index="baiduIndex"
                :rank="rank"
                :tieba-info="tiebaInfo"
                :container="container"
                :baike-titles="appDetail.title_list || []"
                :baike-blocks="appDetail.block_list || []"
                :is-show-wiki-guide="isShowWikiGuide"
                :is-shop="appDetail.is_shop"
                :is-scroll-change="isScrollChange"
                :contact-info="appDetail.contact_info"
                :developer-word="appDetail.developer_word"
                :user-status="appDetail.userStatus || {}"
                :privacy-info="privacyInfo || {}"
                :official-joined="appDetail.officialJoined"
                :package-list="packageList"
                :is-show-score="!isSem"
                :app-type="appDetail.appType"
                :rank-list="rankList"
                @baikeContentShow="baikeContentShow"
                @givepriceTrendData="givepriceTrendData"
                @toRankList="jumpToRank"
            />
        </section>
        <section v-if="!isMobile && (metacritic || Object.keys(evapraise).length)" class="c-gap-top">
            <detail-eval
                :mc-data="appDetail.metacritic"
                :steam-data="appDetail.praise"
            />
        </section>
        <!-- 攻略模块 -->
        <section
            v-if="appDetail.strategy_list || appDetail.strategy_tag"
            class="c-gap-top"
        >
            <strategy-module
                :strategy-tag="appDetail.strategy_tag"
                :strategy-list="appDetail.strategy_list"
                :app-id="appDetail.appId"
            />
        </section>
        <section
            v-if="video" ref="video"
            class="c-gap-top"
        >
            <detail-video
                :video-doc="video"
            />
        </section>
        <!-- 评测区域 -->
        <section
            v-if="(mediaEvaluation && mediaEvaluation.list && mediaEvaluation.list.items)
                || (personEvaluation && personEvaluation.list)" ref="evaluation"
        >
            <!-- 媒体评测 -->
            <section v-if="mediaEvaluation && mediaEvaluation.list && mediaEvaluation.list.items" ref="mediaEvalua">
                <media-eva
                    :eva-list="mediaEvaluation.list.items"
                    :app-id="appDetail.appId"
                />
            </section>
            <!-- 达人评测 -->
            <section v-if="personEvaluation && personEvaluation.list" ref="personEvalua">
                <person-eva
                    :eva-list="personEvaluation.list"
                    :app-id="appDetail.appId"
                />
            </section>
        </section>
        <section v-if="praise && !isSem" class="c-gap-top">
            <detail-score
                :app-id="appDetail.appId"
                :score-data="scoreData"
                tab="detail"
            />
        </section>
        <section
            v-if="comment && comment.list && comment.list.length > 0" ref="comment"
            class="c-gap-top-90"
        >
            <detail-comment
                :comment-doc="comment"
                :need-toggle="true"
            />
        </section>
        <section
            v-if="tieba && !isSem" ref="tieba"
            class="c-gap-top"
        >
            <detail-tieba
                :tieba-doc="tieba"
            />
        </section>
        <section
            v-if="appDetail.appType === 12 && appDetail.officialJoined === false"
            class="c-gap-top pc-rank-list"
        >
            <pcranklist/>
        </section>
        <section
            v-if="appDetail.appType === 11"
            id="relevantRankList"
            class="c-gap-top"
        >
            <rele-vant-rank-list
                v-if="isIOS"
                :rank-title="'王者荣耀相关热门榜单'"
                :rank-list-tab="rankListTab"
                :rank-list="rankList"
                :info="info"
            />
            <new-rele-vant-rank-list v-else/>
        </section>
        <section v-if="mustPlayList && mustPlayList.length && appDetail.appType === 11" class="c-gap-top">
            <rank-list
                :rank-title="'必玩游戏'"
                :rank-list-info="mustPlayList"
                :info="info"
            />
        </section>
        <section v-if="guessLikeGames && guessLikeGames.length && appDetail.appType === 11" class="c-gap-top">
            <rank-list
                :rank-title="'猜你喜欢'"
                :rank-list-info="guessLikeGames"
                :info="info"
            />
        </section>
        <section v-if="isShowWikiGuide">
            <wiki-guide-btn
                @showWikiGuide="showWikiGuide"
                @closeWikiGuide="closeWikiGuide"
            />
        </section>
    </div>
</template>

<script>
import ScreenShot from './detail/app-screen-shot';
import DetailInfo from './detail/app-detail-info';
import WikiGuideBtn from './detail/app-detail-wiki-guide-btn';
import StrategyModule from './detail/app-detail-strategy.vue';
import Pcranklist from './detail/app-detail-pcranklist.vue';
import RankList from './detail/app-detail-rank-list.vue';
import ReleVantRankList from './detail/app-detail-relevant-rank-list.vue';
import NewReleVantRankList from './detail/app-detail-new-relevant-rank-list.vue';
import {isIOS} from '@/utils/browser';
import {getDeepValue} from '@/utils/utility.js';
import {getQueryString} from '@/utils/url';
import api from '@/api';
export default {
    components: {
        ScreenShot,
        DetailInfo,
        WikiGuideBtn,
        DetailVideo: () => import(/* webpackChunkName: 'zone-fpReady' */ './detail/app-detail-video'),
        DetailScore: () => import(/* webpackChunkName: 'zone-fpReady' */ './detail/app-detail-score'),
        MediaEva: () => import(/* webpackChunkName: 'zone-fpReady' */ './detail/app-detail-media-eva'),
        PersonEva: () => import(/* webpackChunkName: 'zone-fpReady' */ './detail/app-detail-person-eva'),
        DetailComment: () => import(/* webpackChunkName: 'zone-scoll' */ './detail/app-detail-comment'),
        DetailTieba: () => import(/* webpackChunkName: 'zone-scoll' */ './detail/app-detail-tieba'),
        StrategyModule,
        Pcranklist,
        RankList,
        ReleVantRankList,
        NewReleVantRankList,
    },
    props: {
        appDetail: {
            type: Object,
            required: true,
        },
        appName: {
            type: String,
            default: '',
        },
        appType: {
            type: Number,
            default: 0,
        },
        scoreData: {
            type: Object,
            default: () => ({}),
        },
        loadMoreComponents: {
            type: Boolean,
            default: false,
        },
        isLogin: {
            type: Boolean,
            default: false,
        },
        isSem: {
            type: Boolean,
            default: false,
        },
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            tieba: this.handleData(11),
            video: this.handleData(1),
            comment: this.handleData(10),
            discussZone: this.handleData(12),
            officialTimeAxis: this.handleData(18),
            mediaEvaluation: this.handleData(16),
            personEvaluation: this.handleData(17),
            praise: this.appDetail.mark,
            info: {},
            media: [], // 顶部缩略图资源
            mediaWeak: [], // 下部的资源
            isMobile: true,
            isVertical: false,
            videoisVertical: false,
            isIOS: isIOS(),
            buyUrlInfo: {},
            isCooperation: '',
            downloadNum: '',
            baiduIndex: '',
            rank: 0,
            container: 0,
            isShowWikiGuide: false,
            windowHeight: 0,
            scrollTop: 0,
            isScrollChange: false,
            privacyInfo: {},
            appId: '',
            priceTrendData: {},
            priceTrendText: '',
            rankListTab: 0,
            rankList: [],
            mustPlayList: [], // 必玩榜单
            guessLikeGames: [], // 猜你喜欢榜单
        };
    },
    computed: {
        metacritic() {
            return getDeepValue(this.appDetail, 'metacritic') || '';
        },
        evapraise() {
            return getDeepValue(this.appDetail, 'praise') || {};
        },
        packageList() {
            return this.appDetail.package_list ? this.appDetail.package_list : [];
        },
        isShowProductDetail() {
            if (this.info.goods_info) {
                return true;
            }
            return false;

        },
    },
    async created() {
        const {
            platBaseInfo,
            publisher,
            appId,
            privacy,
            version,
            permission,
        } = this.appDetail;
        this.appId = appId;
        let tags = this.appDetail.tags ? this.appDetail.tags : [];
        const scoreCount = getDeepValue(this.appDetail, 'mark.score_count');
        let score = (scoreCount >= 10 && !this.isSem)
            ? (this.appDetail.score || getDeepValue(this.appDetail, 'mark.score'))
            : '';
        this.info = {...this.appDetail, tags, score};
        await api.zone.getRankList({
            data: {
                query: getQueryString('query'),
                tag_list: this.info.tags?.join(','),
                app_id: getQueryString('appId'),
                is_h5: true,
                channel: getQueryString('channelid'),
                from: '5617h5',
                src_id: getQueryString('srcid'),
            },
        }).then(res => {
            this.rankList = res.rank_list;
            this.mustPlayList = res.must_play_games;
            this.guessLikeGames = res.guess_like_games;
        });
        let videos = this.appDetail.officialVideo || [];
        let images = this.appDetail.officialPic || [];
        videos.forEach(item => {
            item.type = 1;
            item.poster = item.cover;
            item.direction = item.width - item.height > 0 ? 'h' : 'v';
        });
        images.forEach(item => {
            item.type = 2;
            item.poster = item.url;
            item.direction = item.width - item.height > 0 ? 'h' : 'v';
        });

        if (images[0] && images[0].direction === 'v') {
            this.isVertical = true;
        }
        if (videos[0] && videos[0].direction === 'v') {
            this.videoisVertical = true;
        }
        // 非官方入驻
        if (!this.$root.officialJoinedStyle) {
            // 竖图
            if (this.isVertical) {
                // 竖向视频
                if (this.videoisVertical) {
                    this.mediaWeak = videos.concat(images);
                }
                else {
                    this.media = videos;
                    this.mediaWeak = images;
                }
            }
            // 横图
            else {
                this.media = videos.concat(images);
            }
        }
        else {
            this.mediaWeak = videos.concat(images);
        }
        if (this.appDetail.appType !== 11 && this.appDetail.appType !== 16) {
            this.isMobile = false;
        }
        if (this.appDetail.block_list && this.appDetail.block_list.length) {
            this.isShowWikiGuide = true;
        }
        if (this.isMobile) {
            this.privacyInfo = {
                privacy: platBaseInfo.Android.privacy,
                publisher: platBaseInfo.Android.publisher,
                version: platBaseInfo.Android.version,
                appId,
                permission: platBaseInfo.Android.permission,
                platBaseInfo,
                isShowPermissionURL: platBaseInfo?.Android?.isShowPermissionURL || '',
            };
        }
        else {
            this.privacyInfo = {
                privacy,
                publisher,
                version,
                appId,
                permission,
                platBaseInfo,
            };
        }
        // 如果有商品信息，不展示百科指引按钮
        if (this.appDetail.goods_info) {
            this.isShowWikiGuide = false;
        }
    },
    mounted() {
        const timer = setTimeout(() => {
            const container = this.$refs.detailContainer && this.$refs.detailContainer.getBoundingClientRect().top;
            let anchorPoint = this.getAnchorPointFromUrl(window.location.href);
            let top = 0;
            if (anchorPoint === 'comment') {
                top = this.$refs.comment && this.$refs.comment.getBoundingClientRect().top - container - 10 || 0;
            }
            if (anchorPoint === 'tieba') {
                top = this.$refs.tieba && this.$refs.tieba.getBoundingClientRect().top - container - 10 || 0;
            }
            if (anchorPoint === 'officialNews') {
                const officialNewsEl = document.getElementById('officialNews');
                top = officialNewsEl && officialNewsEl.getBoundingClientRect().top - container - 10 || 0;
            }
            if (anchorPoint === 'wikiModule') {
                const baikeEl = document.getElementById('baike-wrapper');
                top = baikeEl && baikeEl.getBoundingClientRect().top - container - 30 || 0;
            }
            if (anchorPoint === 'previewModule') {
                const officialVideoEl = document.getElementById('officialVideo');
                top = officialVideoEl && officialVideoEl.getBoundingClientRect().top - container - 10 || 0;
            }
            if (anchorPoint === 'mediaEvalua') {
                top = this.$refs.mediaEvalua
                    && this.$refs.mediaEvalua.getBoundingClientRect().top - container - 10 || 0;
            }
            if (anchorPoint === 'personEvalua') {
                top = this.$refs.personEvalua
                    && this.$refs.personEvalua.getBoundingClientRect().top - container - 10 || 0;
            }
            if (anchorPoint === 'evaluation') {
                top = this.$refs.evaluation && this.$refs.evaluation.getBoundingClientRect().top - container || 0;
            }
            this.container = container;
            if (top) {
                window.scrollTo({
                    top: top,
                });
            }
            clearTimeout(timer);
        }, 500);
        this.checkDeepValue();
        this.windowHeight = document.body.offsetHeight;
        if (this.video) {
            const container = this.$refs.detailContainer && this.$refs.detailContainer.getBoundingClientRect().top;
            let scrollTop = this.$refs.video && this.$refs.video.getBoundingClientRect().top - container - 10 || 0;
            this.scrollTop = scrollTop;
        }
    },
    updated() {
        if (getQueryString('from') === 'rank') {
            this.toRankList();
        }
    },
    methods: {
        handleData(key) {
            return this.appDetail.modules.filter(item => {
                return item.moduleId === key;
            })[0];
        },
        getAnchorPointFromUrl(url = '') {
            if (!url) {
                return {};
            }
            const arr = /\?(.*)/.exec(url);
            if (!arr || arr.length < 1) {
                return {};
            }
            let anchorPoint = '';
            const queryStr = arr[1];
            queryStr.split('#').forEach(query => {
                anchorPoint = query;
            });
            return anchorPoint;
        },
        checkDeepValue() {
            let oldId = getDeepValue(this.appDetail, 'oldId');
            this.isCooperation = oldId;
            let downloadNum = getDeepValue(this.appDetail, 'downloadNum') || '';
            this.downloadNum = downloadNum;
            let baiduIndex = getDeepValue(this.appDetail, 'baiduIndex') || '';
            this.baiduIndex = baiduIndex;
            // 获取渠道的数据
            let buyUrlInfo = getDeepValue(this.appDetail, 'buy_url_infos') || {};
            this.buyUrlInfo = buyUrlInfo;
        },
        showWikiGuide(e) {
            this.isShowWikiGuide = e;
        },
        closeWikiGuide(e) {
            this.scrollToTop();
            const timer = setTimeout(() => {
                clearTimeout(timer);
                this.isShowWikiGuide = e;
            }, 600);
            let content = {
                value: 'gameWiki',
                ext: {
                    id: '',
                    ext: Object.assign({moduleName: '查看百科，了解游戏'}, this.$root.extData),
                    pos: '',
                },
            };
            this.$logger.click(content);
        },
        scrollToTop() {
            const baikeWrapper = document.getElementsByClassName('baike-wrapper')[0];
            if (baikeWrapper) {
                const timer = setTimeout(() => {
                    clearTimeout(timer);
                    window.scrollTo({
                        top: baikeWrapper.offsetTop - Math.floor(350 * (window.innerWidth / 1242)),
                    });
                    this.isScrollChange = !this.isScrollChange;
                }, 500);
            }
        },
        baikeContentShow() {
            this.isShowWikiGuide = false;
        },
        maskClick() {
            this.showMask = false;
        },
        toRankList() {
            const jumpApp = document.querySelector('.pc-rank-list');
            jumpApp.scrollIntoView({behavior: 'smooth', block: 'start'});
        },
        givepriceTrendData(priceTrendData, priceTrendText) {
            this.priceTrendData = priceTrendData;
            this.priceTrendText = priceTrendText;
            this.priceTrendText = priceTrendData.price_list[0].price_trend_text;
        },
        jumpToRank(index) {
            this.rankListTab = index;
            const jumpToRank = document.querySelector('.rank-relevant-list');
            jumpToRank.scrollIntoView({block: 'start'});
            window.scrollBy(0, -80);
        },
    },
};

</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    .app-detail-container {
        position: relative;
        padding-bottom: px2rem(200);
        .c-gap-top {
            margin-top: px2rem(100);
        }
        .c-gap-top-90 {
            margin-top: px2rem(90);
        }
        .c-gap-top-60 {
            margin-top: px2rem(60);
        }
    }
</style>